import i18n from 'i18n';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: Record<string, GenericFormItem[]> = {
  confirmation: [
    {
      gridXs: 12,
      label: i18n.t('SALT.REASON_SALT_KEY'),
      stateKey: 'action_reason',
    },
  ],
  virtualizer: [
    {
      gridXs: 3,
      label: 'VIRTUALIZER_KEY',
      stateKey: 'user_connection.virtualizer',
      isSelect: true,
      options: [
        { value: '', label: '' },
        { value: 'connect', label: 'ConnectSky' },
        {
          value: 'rdp',
          label: `Microsoft Remote Desktop (${i18n.t('FILE_KEY')})`,
        },
        {
          value: 'rdp_direct',
          label: 'Microsoft Remote Desktop (Direct Connect)',
        },
        { value: 'rdp_app', label: 'Microsoft Remote Desktop (RemoteApp)' },
        { value: 'connect_direct', label: 'ConnectSky (Direct Connect)' },
        { value: 'tsplus', label: 'TSPlus (WebBrowser HTML5)' },
        { value: 'tsplus_remote_app', label: 'TSPlus (RemoteApp)' },
        {
          value: 'tsplus_all',
          label: 'TSPlus (WebBrowser HTML and RemoteApp)',
        },
      ],
    },
    {
      gridXs: 2,
      label: 'PRIMARY_PORT_KEY',
      stateKey: 'user_connection.connect_port',
      type: 'number',
    },
    {
      gridXs: 2,
      label: 'SECONDARY_PORT_KEY',
      stateKey: 'user_connection.web_port',
      type: 'number',
    },
  ],
};

export default fields;
